import { render } from "./sidebar_shell.html?vue&type=template&id=33e7516f&external"
import script from "./sidebar_shell.js?vue&type=script&lang=js&external"
export * from "./sidebar_shell.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__